/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Body3(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Body3.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Body3.geometry}
        material={nodes.Body3.material}
        position={[0, 117.62, 3.3]}
      >
        <meshPhysicalMaterial
          color={colorArr[3]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Body3.glb')
